
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thanks/purchase",
      function () {
        return require("private-next-pages/thanks/purchase.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thanks/purchase"])
      });
    }
  